
<section class="breadcrumb-section">
    <div class="container">
        <div class="row">
            <div class="col-md-12">
                <div class="breadcrumb-title">
                    <h1>Admission Helpline</h1>
                </div>
            </div>
        </div>			
    </div>	
</section>  

<section class="section-lg std-scholarship">
    <div class="container">
        <div class="col-md-12">
            <div class="inner-title"  >
                <h4>Admission Helpline</h4>							
                
            </div>
            <div class="table-responsive" > 
                <table class="table table-bordered tbl_custom">
                    <thead>
                        <tr>
                            <th width="30%">Section</th>
                            <th width="70%">Phone Number</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>Admission Helpline</td>
                            <td><a href="tel:8551098007">8551098007</a>, <a href="tel:9307900681">9307900681</a>, <a href="tel:8888865509">8888865509</a></td>
                        </tr>
                        <tr>
                            <td>Whats app No.</td>
                            <td><a href="tel:8551098007">8551098007</a>,<a href="tel:9307900682">9307900682</a></td>
                        </tr>
                        <tr>
                            <td>Admission Email-ID</td>
                            <td><a href="mailto:enquiry.admissions@raisoni.net"> enquiry.admissions@raisoni.net</a></td>
                        </tr>
                        <tr>
                            <td>Campus Address</td>
                            <td>G H Raisoni College Of Commerce Science & Technology
                                <br> Khasra No. 50, Plot No.1, Near CRPF Gate No. 3, Madhav Nagri, Nagpur, Maharashtra 440016</td>
                        </tr>
                        <tr>
                            <td>Corporate Office Address:</td>
                            <td>Raisoni Group of Institutions,
                            <br> 345, Shradha House (First Floor), Kingsway, Nagpur – 440 028
                            </td>
                        </tr>
                        <tr>
                            <td colspan="3" width="100%">The admission helpline is operational from 9:00 am to 6:30 pm.</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</section>

